// extracted by mini-css-extract-plugin
module.exports = {"section":"Detail_section__NsBW4","tags":"Detail_tags__H25T7"};